import axios from 'axios';
import { globalURLS } from '../../../Global/urls';
import { IAssesmentPayload } from './typings';

export const cruAssessment = async (
    payload: IAssesmentPayload,
    onSuccess?: (payload: IAssesmentPayload, mode: 'create' | 'edit') => void,
    onFailure?: () => void,
) => {
    const mode = payload.id ? 'edit' : 'create';

    formatPayload(payload);

    try {
        const { data } = await axios.post(
            `${globalURLS.baseURL}cru_assessment`,
            payload,
            globalURLS.config,
        );

        if (data?.success) {
            if (data.data.id) {
                payload.id = data.data.id;
                payload.data.id = data.data.id;
            }
            onSuccess?.(payload, mode);
        } else {
            onFailure?.();
        }
    } catch (error) {
        console.log(error);
        onFailure?.();
    }
};

export const formatPayload = (payload: IAssesmentPayload) => {
    if (!payload.id) {
        payload.id = undefined;
        payload.data.id = undefined;
    }

    if (!payload.for_discussion) {
        payload.discussionid = undefined;
    }

    if (!payload.data.onCompleteAction) {
        payload.data.onCompleteAction = undefined;
    }

    if (!payload.data.buttonCopies) {
        return;
    }
    let buttonCopies = false;
    Object.keys(payload.data.buttonCopies).forEach(
        (key: 'START' | 'SUBMIT' | 'NEXT') => {
            if (payload.data.buttonCopies[key]) {
                buttonCopies = true;
            } else {
                payload.data.buttonCopies[key] = undefined;
            }
        },
    );
    if (!buttonCopies) {
        payload.data.buttonCopies = undefined;
    }
};

export const getNewAssessmentObject = (): IAssesmentPayload => {
    const assessment: IAssesmentPayload = {
        id: '',
        data: {
            id: '',
            ismandatory: false,
            successCopy: '',
            screens: [],
            buttonCopies: {
                START: '',
                SUBMIT: '',
                NEXT: '',
            },
            onCompleteAction: '',
            automate_wa_reg1: false,
            automate_wa_reg1_enddate: '',
        },
        istest: false,
        for_discussion: false,
        discussionid: '',
        preorpost: 'pre',
        name: '',
    };

    return assessment;
};

export const searchAssessment = (
    assessments: IAssesmentPayload[],
    query: string,
): IAssesmentPayload[] => {
    if (query) {
        return assessments.filter(
            assessment =>
                assessment?.id?.toLowerCase?.() === query.toLowerCase() ||
                assessment?.name
                    ?.toLowerCase?.()
                    .includes(query.toLowerCase()) ||
                assessment?.discussionid?.toLowerCase?.() ===
                query.toLowerCase(),
        );
    }
    return assessments;
};
